//
//
//
//
//
//
//
//
//
import annotation from "../mixins/chart/annotation.js";
import tooltip from "../mixins/chart/tooltip.js";
export default {
  mixins: [annotation, tooltip],
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      series: [],
      dataName: "dataSeries"
    };
  },
  methods: {
    $ready: function $ready() {
      this.series.clear();
      this.renderData(this.spec.dataSeries);
      this.fetchNext(this.spec.nextPage);
    },
    fetchData: function fetchData(url) {
      var _this = this;

      var vm = this;
      Utils.type.ifString(url, function (val) {
        Utils.http.execute({
          url: val
        }, "GET", _this, function (response) {
          vm.renderData(response.dataSeries);
          vm.fetchNext(response.nextPage);
        });
      });
    },
    fetchNext: function fetchNext(nextPage) {
      if (!Utils.type.isObject(nextPage)) {
        return;
      }

      if (nextPage.autoload != "all") {
        return;
      }

      this.fetchData(nextPage.url);
    },
    renderData: function renderData(series) {
      if (!Utils.type.isArray(series)) {
        return;
      }

      var data = series.map(function (element) {
        var dataPoints = {};
        element.points.forEach(function (point) {
          dataPoints[point.x] = point.y;
        });
        return {
          name: element.title,
          data: dataPoints
        };
      });
      this.series = this.series.concat(data);
    }
  }
};